import {
  BusinessListingSkeleton,
  BusinessListingGridSkeleton,
  ProfileSkeleton,
  TokenBalanceSkeleton,
  CardSkeleton,
  TableRowSkeleton,
  TableSkeleton,
  NavigationSkeleton,
} from './SkeletonVariants';

export { default as Skeleton } from './Skeleton';
export {
  BusinessListingSkeleton,
  BusinessListingGridSkeleton,
  ProfileSkeleton,
  TokenBalanceSkeleton,
  CardSkeleton,
  TableRowSkeleton,
  TableSkeleton,
  NavigationSkeleton,
};

// Export as SkeletonVariants object for convenience
export const SkeletonVariants = {
  BusinessListing: BusinessListingSkeleton,
  Profile: ProfileSkeleton,
  Token: TokenBalanceSkeleton,
  Card: CardSkeleton,
  Table: TableSkeleton,
};
